import { RiDashboardHorizontalFill, RiBikeFill } from "react-icons/ri";
import { LuBrain } from "react-icons/lu";
import { FaCar, FaUsers, FaFlag } from "react-icons/fa6";
import { PiBowlFoodFill } from "react-icons/pi";
import { IoIosBusiness } from "react-icons/io";

export const appRoutes = {
  label: "Mind Pulse",
  children: [
    {
      name: "Dashboard",
      icon: <RiDashboardHorizontalFill className="text-2xl mr-3" />,
      to: "/admin/dashboard",
      active: true,
    },
  ],
};

export const userRoutes = {
  label: "Users & Businesses",
  children: [
    {
      name: "Organisations & Groups",
      icon: <IoIosBusiness className="text-2xl mr-3" />,
      to: "/admin/businesses",
      active: true,
    },
    {
      name: "Users",
      icon: <FaUsers className="text-2xl mr-3" />,
      to: "/admin/users",
      active: true,
    },
  ],
};

export const recipeRoutes = {
  label: "Recipes",
  children: [
    {
      name: "Recipes",
      icon: <PiBowlFoodFill className="text-2xl mr-3" />,
      to: "/admin/recipes",
      active: true,
    },
  ],
};

export const exerciseRoutes = {
  label: "Exercise",
  children: [
    {
      name: "Exercise Routines",
      icon: <RiBikeFill className="text-2xl mr-3" />,
      to: "/admin/exercise-routines",
      active: true,
    },
  ],
};

export const audioRoutes = {
  label: "Audio Content",
  children: [
    {
      name: "Mindfulness",
      icon: <LuBrain className="text-2xl mr-3" />,
      to: "/admin/mindfulness",
      active: true,
    },
    {
      name: "Virtual Commute",
      icon: <FaCar className="text-2xl mr-3" />,
      to: "/admin/virtual-commute",
      active: true,
    },
  ],
};

export const generalFunctionalityRoutes = {
  label: "General Functionality",
  children: [
    {
      name: "App Reports",
      icon: <FaFlag className="text-2xl mr-3" />,
      to: "/admin/app-reports",
      active: true,
    },
  ],
};

export default [
  appRoutes,
  userRoutes,
  recipeRoutes,
  exerciseRoutes,
  audioRoutes,
  generalFunctionalityRoutes,
];
